import { BackstageOverrides } from '@backstage/core-components';
import { alpha, Theme } from '@mui/material/styles';
import {
  getFocusRing,
  getSurfaceBorder,
  getSurfaceColor,
  getThemeTokens,
  radii,
} from '../tokens';

export const styledMuiButton = (
  theme: Theme,
): BackstageOverrides['MuiButton'] => {
  const tokens = getThemeTokens(theme);

  return {
    root: {
      borderRadius: radii.sm,
      fontWeight: 700,
      minHeight: 40,
      minWidth: theme.spacing(6),
      padding: theme.spacing(0.875, 1.75),
      textTransform: 'none',
    },
    text: {
      color: theme.palette.primary.dark,
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.06),
      },
      '&.Mui-focusVisible': {
        boxShadow: getFocusRing(theme),
      },
    },
    contained: {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none',
      },
      '&.Mui-focusVisible': {
        boxShadow: getFocusRing(theme),
      },
    },
    containedPrimary: {
      backgroundColor: theme.palette.primary.main,
      border: `1px solid ${alpha(theme.palette.primary.dark, 0.08)}`,
      color: '#FFFFFF',
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        color: '#FFFFFF',
      },
    },
    outlined: {
      backgroundColor: getSurfaceColor(theme, 'raised'),
      borderColor: getSurfaceBorder(theme, 'strong'),
      color: tokens.textPrimary,
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.04),
        borderColor: theme.palette.primary.main,
      },
      '&.Mui-focusVisible': {
        boxShadow: getFocusRing(theme),
      },
    },
  };
};
